import { useEffect, useState } from "react";

const MODAL_SELECTOR = [
  '[role="dialog"][data-state="open"]',
  '[role="alertdialog"][data-state="open"]',
  '[aria-modal="true"]',
].join(",");

/**
 * True while any modal window (Radix Dialog, Sheet, AlertDialog, vaul Drawer)
 * is open, so the mobile navigation can slide away behind it. Popovers also
 * use role="dialog" but live inside a popper wrapper, so they are ignored.
 */
export function useModalOpen(): boolean {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const check = () => {
      const found = Array.from(document.querySelectorAll(MODAL_SELECTOR)).some(
        (el) => !el.closest("[data-radix-popper-content-wrapper]")
      );
      setOpen(found);
    };
    check();
    const observer = new MutationObserver(check);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-modal", "data-state", "role"],
    });
    return () => observer.disconnect();
  }, []);

  return open;
}
